<template>
  <div class="af-card">
    <p class="is-size-4 has-text-weight-bold">
      <span v-if="action === 'registration'">{{
        $t("af:welcome.registration.title")
      }}</span>
      <span v-else>{{ $t("af:welcome.login.title") }}</span>
    </p>

    <button
      id="WelcomeButtonEmailLogin"
      class="af-btn mb-4"
      @click="navigateEmail"
    >
      {{ $t("af:welcome.button.email_login") }}
      <b-icon
        icon-pack="fa"
        icon="envelope"
        type="is-blue"
        size="is-medium"
      ></b-icon>
    </button>
    <button id="WelcomeButtonPhoneLogin" class="af-btn" @click="navigatePhone">
      {{ $t("af:welcome.button.phone_login") }}
      <b-icon
        icon-pack="fa"
        icon="phone-alt"
        type="is-green"
        size="is-medium"
      ></b-icon>
    </button>

    <br />
    <br />

    <div class="change-action mt-5">
      <p v-if="action === 'registration'">
        <span>{{ $t("af:welcome.registration.footer.title") }}</span>
        <router-link id="WelcomeButtonLogin" class="ml-2" to="/login">{{
          $t("af:welcome.registration.footer.button.to_login")
        }}</router-link>
      </p>

      <p v-else>
        <span>{{ $t("af:welcome.login.footer.title") }}</span>
        <router-link
          id="WelcomeButtonRegistration"
          class="ml-2"
          to="/registration"
          >{{
            $t("af:welcome.login.footer.button.to_registration")
          }}</router-link
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  title: "af:page.welcome.title",
  data() {
    return {
      action: "", // registration | login
    };
  },
  watch: {
    "$route.meta.action": {
      immediate: true,
      handler: function () {
        this.action = this.$route.meta.action;
      },
    },
  },
  methods: {
    navigateEmail() {
      if (this.action === "registration") {
        this.$router.push({
          name: "EmailRegistration",
        });
      } else {
        this.$router.push({
          name: "EmailLogin",
        });
      }
    },
    navigatePhone() {
      if (this.action === "registration") {
        this.$router.push({
          name: "PhoneRegistration",
        });
      } else {
        this.$router.push({
          name: "PhoneLogin",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.af-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.af-btn {
  display: block;
  padding: 15px;
  background: white;
  color: #051c3a;
  border: 1.5px solid #051c3a;
  border-radius: 10px;
  font-weight: 500;
  width: 100%;
  position: relative;
  cursor: pointer;

  span.icon {
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

@media only screen and (min-width: 769px) {
  .af-card {
    padding: 32px 36px;
  }

  .change-action {
    margin-top: auto !important;
  }
}
</style>
